<template>
  <el-form-item
    class="form form-date-picker"
    :label="column.label"
    :prop="column.name">
    <el-date-picker
      v-model="form[column.name]"
      @change="onRangeChanged"
      :type="column.datePickerType || 'date'"
      :clearable="column.datePickerClearable || false"
      range-separator="|"
      :placeholder="column.datePickerPlaceholder || 'Date'"
      :start-placeholder="column.datePickerPlaceholderStart || 'Start Date'"
      :end-placeholder="column.datePickerPlaceholderEnd || 'End Date'"
      :format="column.format || FormConstants.EL_DATE_FORMAT_DISPLAY"
      :value-format="column.valueFormat || FormConstants.EL_DATE_FORMAT"
      :picker-options="column.pickerOptions"
      :disabled="disabled">
    </el-date-picker>
  </el-form-item>
</template>

<script>
import _ from 'lodash'
import FormConstants from './formconstants'

export default {
  name: 'form-date-picker',
  components: {
  },
  props: ['column', 'form', 'options', 'data', 'disabled'],
  data () {
    return {
    }
  },
  computed: {
    modules: function () {
      return this.$store.getters.user.modules
    },
    FormConstants: function () {
      return FormConstants
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async refresh () {
    },

    // getData (name) {
    //   if (this.data && this.data[name] && typeof this.data[name] === 'object') {
    //     return this.data[name]
    //   }
    //   return []
    // },

    onRangeChanged () {
      let value = this.form[this.column.name]
      let colinfo = _.assign({}, this.column, { value })
      this.$emit('on-range-changed', colinfo)
    }
  }
}
</script>

<style lang="scss">
@import "../styles/base.scss";

.form-date-picker {
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}

</style>
